export default "__VITE_ASSET__A3cXDGNn__"